import Layout from '@/components/Layout';
import { MonitorForm } from '@/components/MonitorForm';
import { useToast } from "@/components/ui/use-toast";
import { useAuth } from "@/context/AuthContext";
import { useEffect, useState } from 'react';
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { useNavigate, useParams } from 'react-router-dom';

const EditMonitor = () => {
    const [monitor, setMonitor] = useState(null);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const navigate = useNavigate();
    const { toast } = useToast();
    const { axiosInstance } = useAuth();

    useEffect(() => {
        const fetchMonitor = async () => {
            try {
                const response = await axiosInstance.get(`/monitors/${id}/edit`);

                // Transform the monitor data for the form
                const formattedMonitor = {
                    _id: response.data.id,
                    name: response.data.name,
                    actionType: response.data.actionType.toLowerCase(),
                    settings: response.data.settings,
                    interval: parseInt(response.data.interval),
                    organizationId: response.data.organizationId,
                    organizationName: response.data.organizationName
                };
                setMonitor(formattedMonitor);
            } catch (error) {
                console.error('Error fetching monitor:', error);
                toast({
                    title: "Error",
                    description: "Failed to fetch monitor details",
                    variant: "destructive",
                });
                navigate('/monitors');
            } finally {
                setLoading(false);
            }
        };

        fetchMonitor();
    }, [axiosInstance]);

    const handleUpdateMonitor = async (formData) => {


        const response = await axiosInstance.put(`/monitors/${id}`, formData);
        return response;
    };

    return (
        <Layout noContainer>
            {loading ? <LoadingState /> : <MonitorForm initialData={monitor} onSubmit={handleUpdateMonitor} />}
        </Layout>
    );
};

const LoadingState = () => (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center space-x-4 animate-pulse">
        <AiOutlineLoading3Quarters className="text-2xl text-primary animate-spin" />
        <h1 className="text-xl font-semibold">Preparing monitor editor</h1>
    </div>
);

export default EditMonitor;